module.exports = __webpack_public_path__ + "images/application/email-reply-99fe84c9.svg";